import { eventBus, type EventSubscription } from '../platform/eventBus';
import { normalizeUserGuid } from './navigateToUserProfile';

export const FOLLOW_RELATIONSHIP_CHANGED_EVENT =
  'FOLLOW_RELATIONSHIP_CHANGED';

export interface FollowRelationshipChange {
  relatedUserId: number;
  profileUserGuid?: string | null;
  isFollowing: boolean;
}

export interface FollowRelationshipTarget {
  userId?: number | string | null;
  profileUserGuid?: string | null;
}

export const isFollowRelationshipTarget = (
  change: FollowRelationshipChange,
  target: FollowRelationshipTarget,
): boolean => {
  const targetUserId = Number(target.userId);
  if (
    Number.isSafeInteger(targetUserId)
    && targetUserId > 0
    && change.relatedUserId === targetUserId
  ) {
    return true;
  }

  const changedGuid = normalizeUserGuid(change.profileUserGuid)?.toLowerCase();
  const targetGuid = normalizeUserGuid(target.profileUserGuid)?.toLowerCase();
  return Boolean(changedGuid && targetGuid && changedGuid === targetGuid);
};

export const notifyFollowRelationshipChanged = (
  change: FollowRelationshipChange,
): void => {
  eventBus.emit(FOLLOW_RELATIONSHIP_CHANGED_EVENT, change);
};

export const subscribeToFollowRelationshipChanges = (
  listener: (change: FollowRelationshipChange) => void,
): EventSubscription =>
  eventBus.addListener(FOLLOW_RELATIONSHIP_CHANGED_EVENT, listener);
